<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-23 03:55:37
    Description : 圈子
  -->
  <div>
    <div class="page">
      <div class="select-page">
        <div
          class="item"
          :class="{ active: selectActive === 0 }"
          @click="selectClick(0)"
        >
          关注 {{ total1 }}
        </div>
        <div
          class="item"
          :class="{ active: selectActive === 1 }"
          @click="selectClick(1)"
        >
          粉丝 {{ total2 }}
        </div>
        <div
          class="item"
          :class="{ active: selectActive === 2 }"
          @click="selectClick(2)"
        >
          黑名单 {{ total3 }}
        </div>
      </div>
      <div v-if="selectActive === 0" class="box" style="background: #ebebeb">
        <div class="user-item" v-for="(item, i) in dataList" :key="item.id">
          <div class="avatar">
            <el-avatar :size="80" :src="baseUrl + item.to.avatar">
              <img :src="VUE_APP_DEFAULTAVATAR" />
            </el-avatar>
          </div>
          <div class="nickname">
            {{ item.to.nickname || "gaiamount默认名称" }}
          </div>
          <div class="job">
            {{ item.to.job || "职业" }}
          </div>
          <div class="signature">
            {{ item.to.signature || "个性签名" }}
          </div>
          <div style="margin-top: 40px">
            <el-button
              :type="item.followed ? 'info' : 'primary'"
              :icon="item.followed ? 'el-icon-minus' : 'el-icon-plus'"
              @click="follow(item.to.account.id, i)"
              size="mini"
              style="background: #999; border-color: #999; color: #fff"
              round
            >
              {{ item.followed === 1 ? "取消关注" : "关注" }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="selectActive === 1" class="box" style="background: #ebebeb">
        <div class="user-item" v-for="(item, i) in dataList" :key="item.id">
          <div class="avatar">
            <el-avatar :size="80" :src="baseUrl + item.user.avatar">
              <img :src="VUE_APP_DEFAULTAVATAR" />
            </el-avatar>
          </div>
          <div class="nickname">
            {{ item.user.nickname || "gaiamount默认名称" }}
          </div>
          <div class="job">
            {{ item.user.job || "职业" }}
          </div>
          <div class="signature">
            {{ item.user.signature || "个性签名" }}
          </div>
          <div style="margin-top: 40px">
            <el-button
              type="primary"
              @click="banUser(item.user.account.id, i)"
              size="mini"
              round
            >
              移入黑名单
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="selectActive === 2" class="box" style="background: #ebebeb">
        <div class="user-item" v-for="(item, i) in dataList" :key="item.id">
          <div class="avatar">
            <el-avatar :size="80" :src="baseUrl + item.to.avatar">
              <img :src="VUE_APP_DEFAULTAVATAR" />
            </el-avatar>
          </div>
          <div class="nickname">
            {{ item.to.nickname || "gaiamount默认名称" }}
          </div>
          <div class="job">
            {{ item.to.job || "职业" }}
          </div>
          <div class="signature">
            {{ item.to.signature || "个性签名" }}
          </div>
          <div style="margin-top: 40px">
            <el-button
              type="primary"
              @click="banUser(item.to.account.id, i)"
              size="mini"
              round
            >
              移除黑名单
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  followList,
  followedList,
  banList,
  follow,
  banUser,
} from "@/api/personal";
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      VUE_APP_DEFAULTAVATAR: process.env.VUE_APP_DEFAULTAVATAR,
      selectActive: 0,
      dataList: [],
      page: {
        pageIndex: 1,
        pageSize: 8,
        total: 1,
      },
      total1: 0,
      total2: 0,
      total3: 0,
    };
  },
  created() {
    this.followList();
    this.followedList(1, false);
    this.banList(1, false);
  },
  methods: {
    /**
     * 切换页面
     */
    selectClick(i) {
      this.dataList = [];
      this.selectActive = i;
      this.getList();
    },
    getList(pageIndex = 1) {
      if (this.selectActive === 0) {
        this.followList(pageIndex);
      } else if (this.selectActive === 1) {
        this.followedList(pageIndex);
      } else if (this.selectActive === 2) {
        this.banList(pageIndex);
      }
    },
    /**
     * 关注 取消关注
     */
    follow(id, index) {
      follow(id)
        .then((res) => {
          this.$message.success("操作成功");
          if (this.dataList[index].followed) {
            this.dataList[index].followed = false;
          } else {
            this.dataList[index].followed = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("操作失败");
        });
    },
    /**
     * 拉黑/取消拉黑
     */
    banUser(id, index) {
      banUser(id)
        .then((res) => {
          this.$message.success("操作成功");
          this.getList(this.page.pageIndex);
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("操作失败");
        });
    },
    followList(pageIndex = 1, flush = true) {
      this.page.pageIndex = pageIndex;
      followList(this.page).then((res) => {
        this.dataList = res.followList;
        this.total1 = res.page.total;
        if (flush) {
          this.flushPage(res);
        }
      });
    },
    followedList(pageIndex = 1, flush = true) {
      this.page.pageIndex = pageIndex;
      followedList(this.page).then((res) => {
        this.total2 = res.page.total;
        if (flush) {
          this.dataList = res.followList;
          this.flushPage(res);
        }
      });
    },
    banList(pageIndex = 1, flush = true) {
      this.page.pageIndex = pageIndex;
      banList(this.page).then((res) => {
        this.total3 = res.page.total;
        if (flush) {
          this.dataList = res.followList;
          this.flushPage(res);
        }
      });
    },
    /**
     * 处理分页
     */
    flushPage(res) {
      this.page.pageIndex = res.page.pageIndex;
      this.page.pageSize = res.page.pageSize;
      this.page.total = res.page.total;
      setTimeout(() => {
        this.$forceUpdate();
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.select-page {
  display: inline-block;
  padding: 0 0 10px;
  .item {
    float: left;
    width: 100px;
    height: 30px;
    background: #fff;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #666;
    line-height: 28px;
    text-align: center;
    user-select: none;
    cursor: pointer;
  }
  .item.active {
    background: linear-gradient(90deg, #ff5b67, #ff464c 100%, #ff464c 0);
    color: #fff;
  }
  .item:first-child {
    border-radius: 6px 0 0 6px;
  }
  .item:last-child {
    border-radius: 0 6px 6px 0;
  }
}
.loading-btn {
  margin: 20px 0 0;
  text-align: center;
  cursor: pointer;
}
.page {
  margin: -40px auto 0;
}
.box {
  padding: 40px 0px;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 60px;
}
.user-item {
  display: inline-block;
  width: 285px;
  height: 330px;
  margin: 0 10px 10px 10px;
  padding: 30px;
  border-radius: 8px;
  background: #ffffff;
  text-align: center;
  .nickname {
    margin: 20px 0 0;
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
  .job {
    height: 14px;
    font-size: 12px;
    color: #999;
    line-height: 14px;
    margin: 10px auto 30px;
  }
  .signature {
    font-size: 12px;
    color: #999;
    line-height: 20px;
  }
}
.user-item:nth-child(4n + 1) {
  margin-left: 0;
}
.user-item:nth-child(4n + 4) {
  margin-right: 0;
}
</style>